import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faCheckCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import loading_spinner from '../assets/loading_spinner.gif';
import { Tooltip } from '@mui/material';

export default function ReportTile(props) {
    const { report, index, setOpenDeleteReportModal, setDeleteReportId } = props;
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [checkMark, setCheckMark] = useState(false);

    const handleDownloadPDF = () => {
        if (checkMark === false) {
            setLoadingDownload(true);
            setTimeout(function() { setLoadingDownload(false) }, 200);
            setTimeout(function() { setCheckMark(true) }, 200);
        }
    }

    const handleDeleteBtn = () => {
        setDeleteReportId(report.id);
        setOpenDeleteReportModal(true);
    }

    return (
        <Card
            style={{width: '325px'}}
            className="m-1 pb-2 drop-shadow-md shadow-md shadow-light-gray-3 rounded-xl"
            id={`report-${index}`}
        >
           
            <div className={`flex justify-end z-50 -mb-9`} style={{marginTop: '12px'}}>
                <Tooltip title="Delete">
                    <FontAwesomeIcon
                        icon={faTrash}
                        className="text-2xl text-gray hover:text-dark-gray mr-4 cursor-pointer"
                        onClick={() => handleDeleteBtn()}
                    />
                </Tooltip>
            </div>
            <div
                className={`h-36 w-auto rounded-t-xl`}
                style={{
                    backgroundImage: `url(${report.logo})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover'
                }}
            >
                    <a
                    download
                    target="__blank"
                    href={report.URL}
                    className="hover:no-underline hover:text-black"
                >
                    {loadingDownload ? (
                        <div className='flex justify-center items-center'>
                            <img src={loading_spinner} className='p-1.5 text-center text-white bg-light-gray rounded-full' alt='Loading...' />
                        </div>
                    ) : (
                        <Tooltip title={checkMark ? "PDF already downloaded. Click to download again." : "Download PDF"}>
                            <div className='flex justify-center items-center pt-5'>
                                {checkMark ? (
                                    <FontAwesomeIcon
                                        icon={faCheckCircle}
                                        className='text-4xl text-green p-3 rounded-full bg-light-gray'
                                    />
                                ) : (
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                        onClick={() => handleDownloadPDF()}
                                        className={"text-3xl p-3 rounded-full bg-light-gray hover:bg-light-gray-2"}
                                    />
                                )}
                            </div>
                        </Tooltip>
                    )}
                </a>
            </div>
            <div>
                <div className='mt-1 ml-3'>
                    <p className='text-lg font-semibold mt-2'>{report.title}</p>
                    <div className='flex mt-1'>
                        <div className='mr-3'>
                            <p className=''>Overall position: {report.overallPosition}%</p>
                        </div>
                        <div>
                            <p className=''>Codes analyzed: {report.numCodes}</p>
                        </div>
                    </div>
                    <p className='text-xs mt-2 mb-2 pl-1 text-gray'>Expected negotiation: {report.expectedNegotiation}</p>
                </div>
            </div>
        </Card>
    )
}
